import React, { useEffect, useState } from "react";
import { Input } from "@/components/shadcn/ui/input";
import { Button } from "@/components/shadcn/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/shadcn/ui/card";
import {auth} from '../../../firebase'
import { getTokenFromStorage } from "@/utils/getToken";
import { TokenPayload } from "@/components/navbar/tabs/MenuTabs";
import { jwtDecode } from "jwt-decode";
import { useEmail } from "@/hook/useEmail";


const EmailConfigPage: React.FC = () => {
  const [userId, setUserId] = useState<number | null>(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const {getEmailConfig, addEmailConfig} = useEmail();
    useEffect(() => {
    const fetchTokenData = async () => {
      let token = getTokenFromStorage();
      let decodedToken: TokenPayload | undefined;

      if (token) {
        try {
          decodedToken = jwtDecode<TokenPayload>(token);
          if (decodedToken) {
            setUserId(decodedToken.sub)
          }
        } catch (error) {
          console.error('Erro ao decodificar token:', error);
        }
      }

      if (!decodedToken) {
        setTimeout(() => {
          token = getTokenFromStorage();
          if (token) {
            try {
              decodedToken = jwtDecode<TokenPayload>(token);
              if (decodedToken) {
                setUserId(decodedToken.sub)
              }
            } catch (error) {
              console.error('Erro ao decodificar token:', error);
            }
          }
        }, 3000);
      }
    };
    fetchTokenData();
  }, []);

  useEffect(()=> {
    const EmailConfig = async () => {
      if(userId) {
        const emailConfig = await getEmailConfig(userId);
      setEmail(emailConfig.email);
      setPassword(emailConfig.password);
      }
    }
    EmailConfig();
  },[userId])

  const handleSave = async () => {
    if (!userId) {
      alert("Usuário não autenticado.");
      return;
    }

    const response = await addEmailConfig(userId, email, password);

    if (response) alert("Configuração salva com sucesso!");
    else alert("Erro ao salvar configuração.");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-indigo-200">
      <Card className="w-full max-w-lg shadow-lg rounded-lg bg-white">
        <CardHeader>
          <CardTitle className="text-center text-2xl font-bold">Configuração de E-mail</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Seu e-mail" />
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Senha (App Password)" />
            <Button className="w-full" onClick={handleSave}>Salvar Configuração</Button>
          </div>
          <p className="pt-5 text-base">Você pode utilizar sua senha Gmail, caso prefira gere uma appPassword <a href='https://myaccount.google.com/apppasswords' className='text-blue-400'>Clicando Aqui</a></p>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailConfigPage;
